import { Navigate, useTypedParams } from '@sorare/routing';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import {
  ANY_SPORT_MY_CARDS_COLLECTIONS,
  ANY_SPORT_MY_CARDS_COLLECTIONS_TYPE,
} from '@sorare/core/src/constants/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useIsLaptop } from '@sorare/core/src/hooks/device/useIsLaptop';
import { isRarityStr } from '@sorare/core/src/lib/so5';

import { MyCardsCollectionsPage } from 'components/collections/MyCardsCollectionsPage';

export const CollectionsTypePage = <
  Params extends Record<string, string>,
>() => {
  const { type } = useTypedParams<Params>();
  const isLaptop = useIsLaptop();
  const { generateSportContextPath } = useSportContext();

  if (isLaptop) {
    return (
      <Navigate
        to={generateSportContextPath(ANY_SPORT_MY_CARDS_COLLECTIONS)}
        replace
      />
    );
  }
  if (!isRarityStr(type)) {
    return (
      <Navigate
        to={generateSportContextPath(ANY_SPORT_MY_CARDS_COLLECTIONS_TYPE, {
          params: {
            type: Rarity.limited,
          },
        })}
        replace
      />
    );
  }
  return <MyCardsCollectionsPage rarity={type} />;
};
